import { GameData } from '../games/data';
import { ProductError, ProductErrorType } from '../models';

export class LearnizMedia<T> {
  title?: string;
  subtitle?: string;
  src?: string;
  slug: string;
  type: LearnizMediaType;
  poster?: string;
  params?: T;
  exportableToMediaLibraries?: boolean;
  constructor(media?: LearnizMedia<any>) {
    this.title = media?.title;
    this.subtitle = media?.subtitle;
    this.src = media?.src;
    this.slug = media?.slug;
    this.type = media?.type;
    this.poster = media?.poster;
    this.params = media?.params;
    this.exportableToMediaLibraries = media?.exportableToMediaLibraries || false;
  }

  static validate(media: LearnizMedia<any>, payloadData: any): ProductError[] {
    if (!media.type) {
      return [{ type: ProductErrorType.MISSING, property: 'type', payload: { ...payloadData } }];
    }
    // else
    switch (media.type) {
      case LearnizMediaType.PDF:
      case LearnizMediaType.URL:
      case LearnizMediaType.AUDIO:
      case LearnizMediaType.VIDEO:
        if (!media.src) {
          return [{ type: ProductErrorType.MISSING, property: 'type', payload: { ...payloadData } }];
        }
        break;
      case LearnizMediaType.GAME:
        return GameData.validate(media.params, 'LearnizMedia:' + media.slug, payloadData);
      case LearnizMediaType.IMAGE: // todo should be defined
      default:
        throw new Error(media.type + ' is not currently supported by LearnizMedia.validate');
    }
    return [];
  }
}

export enum LearnizMediaType {
  VIDEO = 'video',
  AUDIO = 'audio',
  IMAGE = 'image',
  GAME = 'game',
  PDF = 'pdf',
  URL = 'url',
}
